export default __webpack_public_path__ + "static/media/Frankie 9781408315934.ca2af417.jpg";